import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHasPermission } from "../../contexts/auth";
import styles from "./settlements.module.css";

export const Settlements = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const canViewProfitability = useHasPermission("settlement.can_view_profitability");

  const basePath = "/settlements";
  const isStatisticsTab = location.pathname.includes(`${basePath}/statistics`);
  const isProfitabilityTab =
    canViewProfitability && location.pathname.includes(`${basePath}/profitability`);
  const tabValue = isProfitabilityTab ? 2 : isStatisticsTab ? 1 : 0;

  return (
    <Box className={styles.container}>
      <Tabs value={tabValue}>
        <Tab label={t("Sale summary")} onClick={() => navigate(basePath)} />
        <Tab label={t("Statistics")} onClick={() => navigate(`${basePath}/statistics`)} />
        {canViewProfitability && (
          <Tab
            label={t("Profitability")}
            onClick={() => navigate(`${basePath}/profitability`)}
          />
        )}
      </Tabs>
      <Box className={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};
